import { Observable } from 'rxjs';
import { CanDeactivateFn } from '@angular/router';

import { CanLeaveComponent } from './can-leave-component.interface';

/**
 * Determines whether a user can navigate away from the current route.
 * This guard invokes the `canLeave` method of the given component if it exists.
 *
 * If the component does not implement a `canLeave` method or if no component is provided,
 * the guard defaults to allowing navigation (returns true).
 *
 * The `canLeave` method of the component can return either a boolean or an Observable<boolean>,
 * indicating whether the user is allowed to leave the route.
 *
 * @type {CanDeactivateFn<CanLeaveComponent>}
 */
export const canLeaveGuard: CanDeactivateFn<CanLeaveComponent> = (component): boolean | Observable<boolean> => {
	if (!component || typeof component.canLeave !== 'function') return true;
	return component.canLeave();
};
